import API from '@/lib/API.js'
import comun from './comun.js'
const observacionesafiliados = {
    namespaced: true,
    state: {
        Lista: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Filtradas = [];
            state.Seleccionado = undefined;
        },
        set(state, datos) {
            state.Lista = datos;
        },
        select(state, datos) {
            state.Seleccionado = datos;
        },
        agregar(state, datos) {
            state.Lista.unshift(datos);
        },
        eliminar(state, id) {
            state.Lista = state.Lista.filter(function (obj) {
                return obj.id_item !== id;
            });
        },
    },
    actions: {
        select({
            commit
        }, datos) {
            commit("select", datos)
        },
        selectPorId({
            commit,
            state
        }, datos) {
            commit("comun/cargando")
            let entidad = state.Lista.find((x) => x.id_item == datos)
            commit("select", entidad)
            commit("comun/fincarga")
        },
        async traerPorIdAfiliado({
            commit
        }, datos) {
            commit("comun/cargando")
            let data = await API.Observaciones_Afiliados.traerPorIdAfiliado(datos);
            commit("set", data)
            commit("comun/fincarga")
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let entidad = {
                id_item: 0,
                descripcion_observacion: ""
            }
            commit("select", entidad)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            let data = []
            let str = ""
            if (state.Seleccionado.id_item != 0) {
                data = await API.Observaciones_Afiliados.modificar(state.Seleccionado);
                str += "Observacion modificada"
            } else {
                data = await API.Observaciones_Afiliados.alta(state.Seleccionado);
                commit("agregar", data)
                str += `Nueva Observacion de alta`
            }
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch
        }, entidad) {
            let data = []
            let str = ""
            if (entidad.id_item != 0) {
                data = await API.Observaciones_Afiliados.modificar(entidad);
                str += "Observacion modificada"
            } else {
                data = await API.Observaciones_Afiliados.alta(entidad);
                commit("agregar", data)
                str += `Nueva Observacion de alta`
            }
            commit("comun/mostrar", str)
        },
        async eliminar({
            commit
        }, id) {
            let str = ""
            if (id != 0) {
                await API.Observaciones_Afiliados.eliminar(id);
                str += "Observacion eliminada"
            }
            commit("eliminar", id)
            commit("comun/mostrar", str)
        },
    },
    modules: {
        comun,
    }
}
export default observacionesafiliados;